import { useSyncExternalStore } from "react";

const starredComputeKeys = new Set<string>();
const starredComputeListeners = new Set<() => void>();

const subscribeToStarredCompute = (listener: () => void) => {
  starredComputeListeners.add(listener);
  return () => {
    starredComputeListeners.delete(listener);
  };
};

const notifyStarredComputeListeners = () => {
  starredComputeListeners.forEach((listener) => listener());
};

export const isStarredComputeKey = (key: string | undefined): key is string =>
  Boolean(key);

export const useStarredCompute = (key: string | undefined) =>
  useSyncExternalStore(
    subscribeToStarredCompute,
    () => (key ? starredComputeKeys.has(key) : false),
    () => false,
  );

export const toggleStarredCompute = (key: string) => {
  if (starredComputeKeys.has(key)) {
    starredComputeKeys.delete(key);
  } else {
    starredComputeKeys.add(key);
  }
  notifyStarredComputeListeners();
};
